// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgRightFilled16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M8.03033 10.0303C7.73744 10.3232 7.26256 10.3232 6.96967 10.0303C6.67678 9.73744 6.67678 9.26256 6.96967 8.96967L8.439 7.5L6.96967 6.03033C6.7034 5.76406 6.6792 5.3474 6.89705 5.05379L6.96967 4.96967C7.26256 4.67678 7.73744 4.67678 8.03033 4.96967L10.0303 6.96967C10.3232 7.26256 10.3232 7.73744 10.0303 8.03033L8.03033 10.0303Z" />
			</Svg>
		);
	}
);
SvgRightFilled16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgRightFilled16;
